import "./SurveyBuilderPage.scss";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { BackArrow } from "../../../assets/icons-components/Icons";
import useSurveyBuilder from "./useSurveyBuilder";
import SurveyComponentPalette from "./SurveyComponentPalette";
import SurveyDetailsFields from "./SurveyDetailsFields";
import SurveyQuestionBuilder from "./SurveyQuestionBuilder";
import SurveyPreviewPane from "./SurveyPreviewPane";
import { onKeyActivate } from "../../../utils/a11y";

export default function SurveyBuilderPage() {
  const {
    formData,
    errors,
    isLoading,
    isEditing,
    handleChange,
    handleQuestionsChange,
    addQuestion,
    handleSave,
    handleCancel,
    unsavedChangesDialogOpen,
    closeUnsavedChangesDialog,
    confirmLeaveWithoutSaving,
  } = useSurveyBuilder();

  return (
    <div className="main1 survey-builder">
            {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}

      <div className="main1_header survey-builder_header">
        <div className="main1_header_left">
          <div
            className="main1_header_left_arrow"
            onClick={handleCancel}
            onKeyDown={onKeyActivate(handleCancel)}
            role="button"
            tabIndex={0}
          >
            <BackArrow onClick={handleCancel} />
            <h3>{isEditing ? "Edit Survey" : "Create Survey"}</h3>
          </div>
        </div>
        <div className="survey-builder_header_actions">
          <Buttons text="Cancel" type="button" onClick={handleCancel} variant="smallsecondary" className="survey-header-btn-cancel" />
          <Buttons text="Save as Draft" type="button" onClick={() => handleSave("draft")} variant="smallsecondary" className="survey-header-btn-draft" />
          <Buttons text="Publish" type="button" onClick={() => handleSave("publish")} variant="smallprimary" className="survey-header-btn-publish" />
        </div>
      </div>

      <div className="survey-builder_grid">
        <div className="survey-builder_col survey-builder_col-palette">
          <SurveyComponentPalette onAdd={addQuestion} />
        </div>

        <div className="survey-builder_col survey-builder_col-main">
          <SurveyDetailsFields formData={formData} errors={errors} onChange={handleChange} />
          <SurveyQuestionBuilder
            questions={formData.questions}
            error={errors.questions}
            onChange={handleQuestionsChange}
          />
        </div>

        <div className="survey-builder_col survey-builder_col-preview">
          <SurveyPreviewPane formData={formData} />
        </div>
      </div>

      <ConfirmDialog
        open={unsavedChangesDialogOpen}
        onClose={closeUnsavedChangesDialog}
        title="Unsaved changes"
        content="You have unsaved changes to this survey. If you leave now, your edits will be lost."
        buttonText="Leave without saving"
        additionalButtonText="Stay on this page"
        onButtonClick={confirmLeaveWithoutSaving}
        severity="warning"
      />
    </div>
  );
}
